"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TriangleIcon = void 0;
const react_1 = __importDefault(require("react"));
const SVGIcon_1 = require("../SVGIcon");
const TriangleIcon = props => (react_1.default.createElement(SVGIcon_1.SVGIcon, Object.assign({}, props, { viewBox: "0 0 34 34" }),
    react_1.default.createElement("g", { transform: "scale(1.1, 1.1)" },
        react_1.default.createElement("path", { d: "M5.1,31H26.87a4.11,4.11,0,0,0,3.68-5.95L19.66,3.27a4.11,4.11,0,0,0-7.35,0L1.42,25.05A4.11,4.11,0,0,0,5.1,31Z", fill: "white" })),
    react_1.default.createElement("g", { transform: "translate(1.5,2)" },
        react_1.default.createElement("path", { d: "M5.1,31H26.87a4.11,4.11,0,0,0,3.68-5.95L19.66,3.27a4.11,4.11,0,0,0-7.35,0L1.42,25.05A4.11,4.11,0,0,0,5.1,31Z" }))));
exports.TriangleIcon = TriangleIcon;
exports.default = exports.TriangleIcon;
